<div *ngIf="membershipsUpdated" class="alert alert-success text-style">Memberships updated successfully!</div>
<div class="container-fluid fonts overall-margin">
    <div class="row">
        <div class="col-md-6" [ngClass]="{'fontFamily-margin': !membershipsUpdated}">
            <div class="col-md-12 col-xs-12 col-sm-12 heading">
                <span class="span-create-edit-hoshin color">ERG Membership Application</span>
                <span class="pt-1" style="font-size: 13px;"><a href="assets/userguides/MembershipScreenUserGuide.pdf" download class="pl-3 download-link">User Guide</a></span>
            </div>
            <div class="col-sm-12 col-md-12 col-xs-12 mt-2 mb-2" style="display:inline-flex">
                <button class="btn btn-danger col-sm-5 col-md-5 col-lg-4 m-1 curve-edge button-font"
                    [ngClass]="{'disableSection': ismyMembershipSelected}" (click)="browseChapters()">Browse
                    Chapters</button>
                <button class="btn btn-danger col-sm-5 col-md-5 col-lg-4 m-1 curve-edge button-font margin-left"
                    [ngClass]="{'disableSection': isbrowseChapterSelected}" (click)="myMemberships()">My
                    Memberships</button>
            </div>

            <div *ngIf="isbrowseChapterSelected" class="bpg-align">
                <div class="mb-3 ml-2 text-secondary information">
                    <span><mat-icon class="info-icon color" style="font-size: 16px;
                        margin-left: 10px;">info</mat-icon></span>
                    <span>ERG membership is voluntary. Browse, Select & Submit to become a Member.</span>
                </div>
                <div style="display:flex;margin-bottom:13px">
                    <div *ngIf="isDefaultSite" class="color text-style font-weight-bold mt-2 margin-left">Regular Memberships
                    </div>
                    <div *ngIf="!isDefaultSite" class="color text-style font-weight-bold mt-2 margin-left">{{siteName}} Memberships
                    </div>
                </div>

                <div class="col-md-12 div-top text-style margin-left m-4 font-weight-bold"
                    *ngIf="isbrowseChapterSelected && isDefaultSite">No available ERG's at this Site for you!</div>
                <div class="col-md-12 div-top text-style margin-left m-4 font-weight-bold"
                    *ngIf="regularBpgList.length == 0 && isbrowseChapterSelected && !isDefaultSite">All ERG's Registered
                    !</div>
                <div class="col-md-12 div-top" *ngFor="let bpgs of regularBpgList ; let i of index">
                    <div class="font-family"> <label for="check{{bpgs.bpgName}}" style="display:inline-flex">
                            <input type="checkbox" name="check{{bpgs.bpgName}}"
                                [checked]="bpgs.checked || bpgs.showLeadership" name="check{{bpgs.bpgName}}"
                                id="check{{bpgs.bpgName}}" (change)="toggleCheckbox($event,bpgs,'regular')">
                            <span class="label-text "></span>
                            <span class="text-style margin-left right-align">{{bpgs.bpgName}} </span>
                        </label>
                        <div class="form font-family col-md-12 div-top leadership mb-2" *ngIf="(bpgs.showLeadership)">
                            <div class="text-medium-style margin-left mb-2"> <span class="color">( Optional )</span>
                                Interested to serve leadership position?
                                Please
                                choose : </div>
                            <div class="flex">
                                <button
                                    class="btn btn-danger curve-edge margin-left position-button button-style phone-style"
                                    [ngClass]="{'disableSection': bpgs.chair == false}"
                                    (click)="selectChapterMembership(bpgs,'chair','regular')">Chair</button>
                                <button class="btn btn-danger curve-edge position-button  button-style phone-style"
                                    [ngClass]="{'disableSection': bpgs.viceChair == false}"
                                    (click)="selectChapterMembership(bpgs,'viceChair','regular')">Vice Chair</button>
                                <button class="btn btn-danger curve-edge position-button button-style phone-style"
                                    [ngClass]="{'disableSection': bpgs.financeChair == false}"
                                    (click)="selectChapterMembership(bpgs,'financeChair','regular')">Finance
                                    Chair</button>
                                <button class="btn btn-danger curve-edge position-button button-style phone-style"
                                    [ngClass]="{'disableSection': bpgs.communicationChair == false}"
                                    (click)="selectChapterMembership(bpgs,'communicationChair','regular')">Communication
                                    Chair</button>
                            </div>
                        </div>

                    </div>
                </div>

                <!-- Virtual Memberships  -->
                <div>
                    <div style="display:flex;margin-bottom:13px">
                        <div class="color text-style font-weight-bold mt-2 margin-left">Virtual Memberships
                        </div>
                    </div>
                    <div class="col-md-12 div-top text-style margin-left m-4 font-weight-bold"
                        *ngIf="virtualBpgList.length==0">All ERG's Registered !</div>

                    <div class="col-md-12 div-top" *ngFor="let bpgs of virtualBpgList ; let i of index">
                        <div class="font-family"> <label for="check{{bpgs.bpgName}}" style="display:inline-flex">
                                <input type="checkbox" name="check{{bpgs.bpgName}}" [checked]="bpgs.checked"
                                    name="check{{bpgs.bpgName}}" id="check{{bpgs.bpgName}}"
                                    (change)="toggleCheckbox($event,bpgs,'virtual')">
                                <span class="label-text "></span>
                                <span class="text-style margin-left right-align"> {{bpgs.bpgName}} </span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 div-top" class="text-style margin-left m-4 font-weight-bold"
                *ngIf="(noMembershipsFound && ismyMembershipSelected) || (!regularMembershipsExists && !virtualMembershipsExists && ismyMembershipSelected)">
                No memberships found!</div>

            <div *ngIf="ismyMembershipSelected && !noMembershipsFound && regularMembershipsExists"
                class="bpg-align ml-4">
                <div *ngIf="isDefaultSite" class="color mb-2">Regular Memberships</div>
                <div *ngIf="!isDefaultSite" class="color mb-2">{{siteName}} Memberships</div>
                <div *ngFor="let data of enrolledBpg">
                    <div *ngIf="data.bpgList.length > 0 && data.isBaseSite">
                        <a (click)="showHideChapterMembership(data.siteName)" class="text-style">
                            <span *ngIf="data.viewSite" class="text-style font-weight-bold">-</span>
                            <span *ngIf="!data.viewSite" class="text-style font-weight-bold">+</span>

                        </a> <span class="text-style font-weight-bold margin-left mb-3">{{data.siteName}}</span>
                        <div *ngIf="data.viewSite" class="mt-2 mb-2">
                            <div *ngFor="let bpg of data.bpgList">
                                <div class="mt-1 mb-1 row" style="margin-left: 20px !important;">
                                    <span class="text-style ml-4" style="margin-top:1%;margin-bottom:1%">{{bpg.bpgName}}
                                        <span class="pt-2 ml-2 cancel color font-delete"><a data-toggle="modal"
                                                data-target="#myModal"
                                                (click)="removeMembership(bpg.bpgId,data.siteId)"><u>Withdraw
                                                    Membership</u></a>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="ismyMembershipSelected && !noMembershipsFound && virtualMembershipsExists"
                class="bpg-align ml-4">
                <div class="color mb-2">Virtual Memberships</div>
                <div *ngIf="ismyMembershipSelected && !noMembershipsFound" class="bpg-align">
                    <div *ngFor="let data of enrolledBpg">
                        <div *ngIf="data.bpgList.length > 0  && !data.isBaseSite">
                            <a (click)="showHideChapterMembership(data.siteName)" class="text-style">
                                <span *ngIf="data.viewSite" class="text-style font-weight-bold">-</span>
                                <span *ngIf="!data.viewSite" class="text-style font-weight-bold">+</span>

                            </a> <span class="text-style font-weight-bold margin-left mb-3">{{data.siteName}}</span>
                            <div *ngIf="data.viewSite" class="mt-2 mb-2">
                                <div *ngFor="let bpg of data.bpgList">
                                    <div class="mt-1 mb-1 row" style="margin-left: 20px !important;">
                                        <span class="text-style ml-4"
                                            style="margin-top:1%;margin-bottom:1%">{{bpg.bpgName}}
                                            <span class="pt-2 ml-2 cancel color font-delete"><a data-toggle="modal"
                                                    data-target="#myModal"
                                                    (click)="removeMembership(bpg.bpgId,data.siteId)"><u>Withdraw
                                                        Membership</u></a>
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6 fontFamily-communication text-style">
            <div class="card ">
                <div class="container font-content" *ngIf="userEmail && !editEmailAllowed">

                    <div class="mt-2">All chapter related notifications shall be communicated to the below email address
                    </div>
                    <div class="color mt-1 mb-1">{{userEmail}} <a *ngIf="isEmailEditable" class="edit-delete ml-2"><img
                                src="assets/images/edit.png" alt="Angular Logo" class="image" title="view" style="width: 20px !important"
                                (click)="editEmail()" /></a>
                    </div>
                </div>
                <div class="container font-content"
                    *ngIf="userEmail == '' || userEmail == undefined || userEmail == null || editEmailAllowed">
                    <h6 style="margin-top:2%;margin-bottom:4%"><b>Missing Email Address:</b></h6>
                    <div class="alert alert-success" *ngIf="emailSent">Email updated successfully!</div>
                    <div class="pb-3">Your email address is missing. Please update to receive all Chapter Membership
                        related notifications.</div>

                    <div style="display:inline-flex" class="email mt-2 mb-2">
                        <input (keyup)="checkEmailType($event)" style="font-size: 0.8rem !important;"
                            class="form-control pb-2" [(ngModel)]="emailAddress">

                        <button class="btn btn-danger curve-edge margin-left btn-update"
                            [disabled]="isEmailInvalid || emailAddress == ''" (click)="updateEmail()">UPDATE</button>
                    </div>
                    <p class="text-medium-style color margin-left mb-2" *ngIf="isEmailInvalid">Please enter a valid
                        email
                        address</p>
                </div>

            </div>

            <div class="card mt-3">
                <div class="container font-content" *ngIf="selectedErg.length > 0 || removeMemberships.length > 0"
                    style="margin-top:10px !important">
                    <h6 class="mt-1 text-style color"><b>Membership Checkout :</b></h6>

                    <div *ngIf="selectedErg.length > 0">
                        <h6 class="mt-3 mb-3 text-style"><b>New Memberships <span class="color">( {{selectedErg.length}}
                                    )</span></b></h6>
                        <div *ngFor="let bpg of selectedErg" class="text-style mb-2  mt-2">
                            <div style="display:inline-flex">
                                <span class="color left-align"><b>></b></span>
                                <span class="ml-3">
                                    <span>{{bpg.bpgName}}</span> - <span class="color font-weight-bold">{{bpg.siteName}}
                                    </span>
                                </span>
                            </div>

                            <div class="text-medium-style mt-2 mb-2 ml-4"
                                *ngIf="bpg.chair || bpg.viceChair || bpg.communicationChair ||bpg.financeChair">
                                Interested
                                in<button class="btn btn-danger curve-edge position-button mb-2 button-style"
                                    *ngIf="bpg.chair" [ngClass]="{'disableSection': bpg.chair}">Chair</button>
                                <button class="btn btn-danger curve-edge position-button  mb-2 button-style"
                                    *ngIf="bpg.viceChair" [ngClass]="{'disableSection': bpg.viceChair}">Vice
                                    Chair</button>
                                <button class="btn btn-danger curve-edge position-button  mb-2 button-style"
                                    *ngIf="bpg.financeChair" [ngClass]="{'disableSection': bpg.financeChair}">Finance
                                    Chair</button>
                                <button class="btn btn-danger curve-edge position-button  mb-2 button-style"
                                    *ngIf="bpg.communicationChair"
                                    [ngClass]="{'disableSection': bpg.communicationChair}">Communication Chair</button>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="removeMemberships.length > 0">

                        <h6 class="mt-3 text-style mb-3"><b>Withdraw Memberships <span class="color">(
                                    {{removeMemberships.length}} )</span></b></h6>
                        <div *ngFor="let member of removeMemberships">
                            <div *ngFor="let bpg of member.bpgList" class="mb-2">
                                <div style="display:inline-flex">
                                    <span class="color left-align"><b>></b></span>
                                    <span class="ml-3">
                                        <span>{{bpg.bpgName}}</span> - <span
                                            class="color font-weight-bold text-style">{{member.siteName}} </span>
                                        <span class="pt-2 ml-2 cancel color font-delete"><a
                                                (click)="undoRemoveMembership(bpg,member.siteId)"><u>Undo</u></a></span>
                                    </span>
                                </div>


                            </div>


                        </div>
                    </div>
                </div>

            </div>
            <div class="mt-2">

                <button class="btn btn-danger submit-button col-md-12 curve-edge mt-2 mb-4"
                    *ngIf="selectedErg.length > 0 || removeMemberships.length > 0"
                    (click)="saveMembership()">Submit</button>
            </div>
            <app-confirmation-modal [PData]="msg" (emitPass)="this[method](param)" id="2"></app-confirmation-modal>

        </div>
    </div>
    <ng-template #callAPIDialog>
        <div class="col-md-12 pl-4 pr-4 mb-2 container-fluid">
            <div class="mt-2">
                <h6>Please select the chapter you wish to enroll as a member :</h6>
            </div>
            <div class="mt-4 mb-4">
                <div *ngFor="let site of bpgsiteList">
                    <div class="font-family text-style popup-bpgNames" style="display: inline-flex;">
                     <div class="float-left">
                        <input type="radio" name="radio" [checked]="site.checked" (change)="toggleRadio(site)">
                        <span class="label-text"></span>
                     </div>
                     <div class="float-right text-style margin-left pb-2 left-align" style="text-align: left;">
                        {{site.siteName}} - {{site.bpgName}}
                     </div>
                    </div>
                </div>
            </div>
            <div class="text-center">
                <button type="button" class="btn btn-danger popup-button text-style mr-lg-2"
                    (click)=" closePopup()">CANCEL</button>
                <button type="button" [disabled]="disableButton" class="btn popup-button btn-danger text-style ml-lg-2"
                    (click)="confirmVirtualMembership()">DONE</button>
            </div>
        </div>
    </ng-template>